<template>
    <b-card no-body>
        
        <b-modal id="create-level" title="Sıra Ekle" no-close-on-esc no-close-on-backdrop>
            <sgk-exit-approval-level-create v-model="createLevelValue"></sgk-exit-approval-level-create>
            <template #modal-footer><v-executer :loading="loading" :action="createLevel">Ekle</v-executer></template>
        </b-modal>
        
        <b-modal id="create-level-title" title="Unvan Ekle" no-close-on-esc no-close-on-backdrop>
            <sgk-exit-approval-level-create-title v-model="createLevelTitleValue"></sgk-exit-approval-level-create-title>
            <template #modal-footer><v-executer :loading="loading" :action="createLevelTitle">Ekle</v-executer></template>
        </b-modal>
        
        <b-overlay :show="getting" opacity="0.2" class="rounded">
            <div class="p-1">
                <button class="btn btn-primary btn-icon rounded-circle text-nowrap" v-on:click="createLevelOpener(null)">
                    <feather-icon icon="PlusIcon" size="16"></feather-icon>
                </button>
            </div>
            <div class="table-responsive mb-0">
                <table class="table table-sm bordered-header">
                    <thead>
                        <tr>
                            <th class="text-center"><feather-icon icon="MoreHorizontalIcon"></feather-icon></th>
                            <th class="w-100">Şube</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(item,i) in (datas || [])">
                            <tr :key="`b-${i}`">
                                <td class="bg-light-secondary">
                                    <b-dropdown boundary="window" size="sm" text="İşlemler" no-caret variant="secondary">
                                        <b-dropdown-item v-on:click="createLevelOpener($safe(item,'SGKBranchId') || null)">Sıra Ekle</b-dropdown-item>
                                    </b-dropdown>
                                </td>
                                <td class="p-50 bg-light-secondary font-weight-bolder">{{ $safe(item,'SGKBranchName') || '' }}</td>
                            </tr>
                            <tr :key="`b-${i}-sub`">
                                <td></td>
                                <td class="p-50">
                                    <div class="table-responsive mb-0">
                                        <table class="table table-sm table-bordered bordered-header">
                                            <tbody>
                                                <template v-for="(level,ii) in ($safe(item,'Levels') || [])">
                                                    <tr :key="`l-${ii}`">
                                                        <td class="text-center bg-light-primary">
                                                            <b-dropdown boundary="window" size="sm" text="İşlemler" no-caret variant="primary">
                                                                <b-dropdown-item v-on:click="createLevelTitleOpener(level)">Unvan Ekle</b-dropdown-item>
                                                                <b-dropdown-item v-on:click="deleteLevel(level)">Sil</b-dropdown-item>
                                                            </b-dropdown>
                                                        </td>
                                                        <td class="bg-light-primary px-1 py-50 w-100">{{ $safe(level,'Level') }}. Sıra</td>
                                                    </tr>
                                                    <tr :key="`l-${ii}-sub`">
                                                        <td></td>
                                                        <td class="p-50">
                                                            <div class="table-responsive mb-0" v-if="($safe(level,'Titles') || []).length > 0">
                                                                <table class="table table-sm table-bordered bordered-header">
                                                                    <tbody>
                                                                        <template v-for="(title,iii) in ($safe(level,'Titles') || [])">
                                                                            <tr :key="`t-${iii}`">
                                                                                <td class="p-25">
                                                                                    <button class="btn btn-icon btn-xs btn-flat-danger" v-on:click="deleteTitle(level,title)">
                                                                                        <feather-icon icon="TrashIcon"></feather-icon>
                                                                                    </button>
                                                                                </td>
                                                                                <td class="w-100">{{ $safe(title,'EmployeeDepartmentTitleName') }}</td>
                                                                            </tr>
                                                                        </template>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                            <div v-else class="text-center">Henüz bir veri bulunmamaktadır.</div>
                                                        </td>
                                                    </tr>
                                                </template>
                                            </tbody>
                                        </table>
                                    </div>
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
        </b-overlay>
    </b-card>
</template>

<script>
import { BCard, BDropdown, BDropdownItem, BOverlay } from 'bootstrap-vue'
import SGKExitApprovalApi from '@/api/sgk-exit-approval';
import SGKExitApprovalLevelCreate from './components/SGKExitApprovalLevelCreate.vue';
import SGKExitApprovalLevelCreateTitle from './components/SGKExitApprovalLevelCreateTitle.vue';

export default {
    components:{
        BCard,
        BDropdown, 
        BDropdownItem,
        BOverlay,
        'sgk-exit-approval-level-create':SGKExitApprovalLevelCreate,
        'sgk-exit-approval-level-create-title':SGKExitApprovalLevelCreateTitle
    },
    mounted(){
        this.get()
    },
    data(){
        return {
            datas: [],
            createLevelValue:{
                BranchChangable:false,
                RequiredConfirmationType:null,
                SGKBranchId:null,
                SendSMS:false
            },
            createLevelTitleValue:{
                RequiredConfirmationType:null,
                EmployeeDepartmentTitleId:null,
                SGKExitApprovalLevelId:null
            },
            getting:false,
            loading:false
        }
    },
    methods:{
        createLevelOpener(branchId){
            this.createLevelValue.BranchChangable = false
            this.createLevelValue.RequiredConfirmationType = null
            this.createLevelValue.SGKBranchId = null
            this.createLevelValue.SendSMS = null
            this.createLevelValue.BranchChangable = branchId ? false : true
            this.createLevelValue.SGKBranchId = branchId || null
            this.$showModal('create-level')
        },
        createLevelTitleOpener(item){
            this.createLevelTitleValue.EmployeeDepartmentTitleId = null
            this.createLevelTitleValue.RequiredConfirmationType = null
            this.createLevelTitleValue.SGKExitApprovalLevelId = null
            this.createLevelTitleValue.SGKExitApprovalLevelId = item.Id          
            this.$showModal('create-level-title')
        },
        createLevel(){
            this.loading = true
            SGKExitApprovalApi.Create(this.createLevelValue).then(res => {
                if(res.data.Success){
                    this.$hideModal('create-level')
                    this.get()
                }
                this.$result(res)
                this.loading = false
            }).catch(err => {
                this.$result(null,err)
                this.loading = false
            })
        },
        deleteLevel(level){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${level.Level}. sırayı ve altındaki bölümleri silecektir.`).then(c => {
                if(c){
                    this.getting = true
                    SGKExitApprovalApi.Delete(level.Id).then(res => {
                        if(res.data.Success){
                            this.get()
                        }
                        this.$result(res)
                        this.getting = false
                    }).catch(err => {
                        this.$result(null,err)
                        this.getting = false
                    })
                }
            })
        },
        deleteTitle(level,title){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${level.Level}. sırasındaki ${title.EmployeeDepartmentTitleName} isimli bölümü silecektir.`).then(c => {
                if(c){
                    this.getting = true
                    SGKExitApprovalApi.DeleteTitle(title.Id).then(res => {
                        if(res.data.Success){
                            this.get()
                        }
                        this.$result(res)
                        this.getting = false
                    }).catch(err => {
                        this.$result(null,err)
                        this.getting = false
                    })
                }
            })
        },
        createLevelTitle(){
            this.loading = true
            SGKExitApprovalApi.CreateTitle(this.createLevelTitleValue).then(res => {
                if(res.data.Success){
                    this.$hideModal('create-level-title')
                    this.get()
                }
                this.$result(res)
                this.loading = false
            }).catch(err => {
                this.$result(null,err)
                this.loading = false
            })
        },
        get(){
            this.getting = true
            SGKExitApprovalApi.List({}).then(res => {
                this.getting = false
                this.datas = res.data || []
            }).catch(e => {
                this.getting = false
                this.$result(null,e)
            })
        }
    }
}
</script>